import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import UserCredential from "../../model/user/UserCredential";
import GetDevicesInteractor from "../../interactor/device/GetDevicesInteractor";

export interface TLoginPresenter extends TLoadingAwarePresenter {
  username: string;
  password: string;
  loginButtonDisabled: boolean;
}

export interface ILoginPresenter extends TLoginPresenter, TPresentable {
  setUsername(username: string): void;
  setPassword(password: string): void;
  login(): void;
  clearFields(): void;
}

const defaultState: TLoginPresenter = {
  username: "",
  password: "",
  loginButtonDisabled: true
};

const LoginPresenter = withStore<ILoginPresenter, TLoginPresenter>(
  ({ application, store, loader, translate }): ILoginPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TLoginPresenter>();

    const changeLoginButtonStatus = () => {
      const { username, password } = _store.getState<ILoginPresenter>();

      store.update({
        loginButtonDisabled: username && password ? false : true
      });
    };

    const setUsername = (username: string) => {
      _store.update({
        username
      });
      changeLoginButtonStatus();
    };

    const setPassword = (password: string) => {
      _store.update({
        password
      });
      changeLoginButtonStatus();
    };

    const clearFields = () => {
      setUsername("");
      setPassword("");
    };

    const login = async () => {
      loader.start("loginLoader");

      const { username, password } = _store.getState<ILoginPresenter>();
      const userCredential = UserCredential({ username, password });

      try {
        const devices = await _application.container
          .resolve<GetDevicesInteractor>("getDevices")
          .execute(userCredential);

        _application.navigator.push(
          {
            pathname: "device-management"
          },
          {
            devices: JSON.stringify(devices)
          }
        );

        clearFields();
      } catch (e: any) {
        loader.stop("loginLoader");

        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute(e.message);
      }
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      setUsername,
      setPassword,
      login,
      clearFields
    };
  },
  defaultState
);

export default LoginPresenter;
